import "./Specialities.css";
import Header from "../Shared/Header/Header";
import Footer from "../Shared/Footer/Footer";

const Specialities = () => {
  return (
    <>
      <Header />
      <Footer />
    </>
  );
};

export default Specialities;